import SteperNewProfile from "../modules/steper";
import style from "./Review.module.scss";
import { Row, Col, Typography, Space, Divider, Button, Modal, Image } from "antd";
import { CheckOutlined } from "@ant-design/icons";
import styled from "styled-components";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { base64ToFile, convertToJalaliWithoutTime, fileToBase64, formatDigit, formatMsisdn } from "../../../../tools/tools";
import { Link, useNavigate } from "react-router-dom";
import { _adr } from "../../../../address";
import Layouts, { useLayouts } from "../../../layout/layouts";
import { from } from "jalali-moment";
import { useAPIPublic } from "../../../../tools/api";
import Loading from "../../../../components/loader/loading";
import { globalValue } from "../../../../reducer/serviceReducerGlobala";
import { clearFormData, simcardPurchase } from "../../../../reducer/serviceReducer";

import { EditOutlined } from "@ant-design/icons";
import { CheckToken } from "../../../../tools/services";

const Review = () => {
	const { queryCurrentUser, queryCurrentUserVProfile, queryCityByCityId, queryActiveProvince, getDocument } = useAPIPublic();

	const dispatch = useDispatch();
	const { Paragraph, Text, Title } = Typography;
	const [openModal, setOpenModal] = useState(false);
	const [isVisible, setIsVisible] = useState(false);
	const [fileDocument, setFileDocument] = useState();
	const [loading, setLoading] = useState();
	const nav = useNavigate();
	const MyModalAuctionResult = styled(Modal)`
		.ant-modal-content {
			.holder_show_content-result {
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				padding: 1rem 0;
				text-align: center;
				.hold_icon {
					width: 4rem;
					height: 4rem;
					margin: auto;
					background: rgba(55, 179, 153, 1);
					border-radius: 50%;
					color: #fff;
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					.anticon {
						font-size: 2rem;
					}
				}
				article {
					h3 {
						text-align: center;
						font-size: 1.5rem;
						font-style: normal;
						font-weight: 500;
						line-height: normal;
						margin: 0.5rem 0 1rem;
					}
					span {
						display: block;
						color: #4d4d4d;
						text-align: right;
						font-size: 1rem;
						font-style: normal;
						font-weight: 400;
						line-height: normal;
					}
				}
			}
			.ant-modal-footer {
				.ant-divider {
					margin-top: 0;
				}
				padding: 0;
				.holder-button {
					.btn-normal {
						width: 100%;
						height: 3.125rem;
					}
				}
			}
		}
	`;
	const Holder_button = styled.div`
		margin-top: 5rem;
	`;
	const formData = useSelector((state) => state?.from?.newUser);

	const { refreshUser, checkLoginUser } = useLayouts();

	//check Login
	const [isLogin, setLogin] = useState();

	//user Info
	const [user, setUser] = useState({});

	useEffect(() => {
		const checkLogin = async () => {
			const isCheck = await checkLoginUser();
			if (isCheck) {
				const userInfo = await refreshUser();
				setUser(userInfo || {});
				if (formData?.hasCompleted && !formData?.hasCompleted) {
					setLogin(false);
				} else {
					setLogin(isCheck);
				}
			}
		};
		checkLogin();
	}, [checkLoginUser, refreshUser]);
	useEffect(() => {
		const callInfo = async () => {
			const temp = await fileToBase64(formData?.profile?.photo);
			setFileDocument(temp || "");
		};
		callInfo();
	}, []);

	useEffect(() => {
		const getProfile = async () => {
			if (isLogin) {
				try {
					setLoading(true);
					const resProfile = await queryCurrentUserVProfile();
					if (resProfile) {
						const cityProvider = await queryCityByCityId(resProfile?.address?.cityid);
						const provinceProvider = await queryActiveProvince();
						const docProvider = await getDocument(resProfile?.documentid);
						setFileDocument(docProvider);
						let profile = {
							fname: resProfile?.fname,
							lname: resProfile?.lname,
							certno: resProfile?.certno,
							birthdate: resProfile?.birthdate,
							fathername: resProfile?.fathername,
							identityno: resProfile?.identityno,
							smsmobileno: "0" + resProfile?.smsmobileno,
							photo: (await base64ToFile(docProvider)) || null,
							gender: resProfile?.gender,
							txtCity: cityProvider?.stR_CityName,
							cityid: resProfile?.address?.cityid,
							txtProvince: provinceProvider?.find((item) => item?.inT__ProvinceId === cityProvider?.intfK_ProvinceId)?.stR_ProvinceName || "",
							provinceid: cityProvider?.intfK_ProvinceId,
							mainStreet: resProfile?.address?.mainstreet,
							auxiliaryRoad: resProfile?.address?.auxiliaryroad,
							alley: resProfile?.address?.alley,
							buildingNo: resProfile?.address?.buildingno,
							floor: resProfile?.address?.floor,
							unit: resProfile?.address?.unit,
							tel: resProfile?.address?.tel,
							postalcode: resProfile?.address?.postalcode,
							bankname: user?.bankname,
							bankaccountnumber: user?.bankaccountnumber,
							cardnumber: user?.cardnumber,
							shebanumber: user?.shebanumber,
							profileid: resProfile?.profileid,
						};
						dispatch(
							simcardPurchase({
								newUser: {
									profile: {
										...profile,
									},
								},
							}),
						);
					}
					setLoading(false);
				} catch (error) {
					console.error(error);
					setLoading(false);
				}
			}
		};
		getProfile();
	}, [isLogin]);

	const [open, setOpen] = useState(false);
	const showModal = () => {
		setOpen(true);
	};

	const handleCancel = () => {
		setOpen(false);
	};

	const handleAcceptFinal = async () => {
		try {
			setLoading(true);
			let _currentUser = await refreshUser(true);
			setUser(_currentUser);
			setLoading(false);
		} catch (error) {
			setLoading(false);
		}
	};
	const handleNavToDirect = async () => {
		setOpenModal(false);
		await refreshUser();
		dispatch(clearFormData(["profile"]));
		nav(_adr.Root + _adr.Landing.Index);
	};
	return (
		<>
			<div className={style.review}>
				<SteperNewProfile current={3} />
				<div className="page_title">
					<h3>
						اطلاعات هویتی{" "}
						{isLogin && (
							<Link to={_adr.Root + _adr.Accounts.Index + _adr.Accounts.NewUser.Index + _adr.Accounts.NewUser.Profile} state={{ type: "edit" }}>
								<EditOutlined />
							</Link>
						)}
					</h3>
				</div>
				<Typography className={style.gapList}>
					<Row gutter={30}>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>نام:</Text>
									<Text strong>{formData?.profile?.fname}</Text>
								</Space>
							</Paragraph>
						</Col>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>نام خانوادگی:</Text>
									<Text strong>{formData?.profile?.lname}</Text>
								</Space>
							</Paragraph>
						</Col>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>کد ملی:</Text>
									<Text strong dir="ltr">
										{formData?.profile?.certno}
									</Text>
								</Space>
							</Paragraph>
						</Col>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>تاریخ تولد: </Text>
									<Text strong dir="ltr">
										{convertToJalaliWithoutTime(formData?.profile?.birthdate)}
									</Text>
								</Space>
							</Paragraph>
						</Col>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>نام پدر:</Text>
									<Text strong>{formData?.profile?.fathername}</Text>
								</Space>
							</Paragraph>
						</Col>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>شماره شناسنامه:</Text>
									<Text strong>{formData?.profile?.identityno}</Text>
								</Space>
							</Paragraph>
						</Col>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>موبایل:</Text>
									<Text strong dir="ltr">
										<span dir="ltr">0{formatMsisdn(formData?.profile?.smsmobileno?.replace("0", ""))}</span>
									</Text>
								</Space>
							</Paragraph>
						</Col>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>کارت ملی </Text>
									<div className="show-document">
										<Button onClick={() => fileDocument && setIsVisible(true)} type="link">
											{fileDocument ? <>بارگذاری شده</> : <>خطای دریافت</>}
										</Button>
										<Image
											preview={{
												visible: isVisible,
												onVisibleChange: (value) => setIsVisible(value),
											}}
											src={fileDocument}
											style={{ display: "none" }}
										/>
									</div>
								</Space>
							</Paragraph>
						</Col>
					</Row>
				</Typography>
				<Divider />
				<div className="page_title">
					<h3>
						اطلاعات آدرس{" "}
						{isLogin && (
							<Link to={_adr.Root + _adr.Accounts.Index + _adr.Accounts.NewUser.Index + _adr.Accounts.NewUser.Address} state={{ type: "edit" }}>
								<EditOutlined />
							</Link>
						)}
					</h3>
				</div>
				<Typography className={style.gapList}>
					<Row gutter={30}>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>استان:</Text>
									<Text strong>{formData?.profile?.txtProvince}</Text>
								</Space>
							</Paragraph>
						</Col>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>شهر:</Text>
									<Text strong>{formData?.profile?.txtCity}</Text>
								</Space>
							</Paragraph>
						</Col>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>خیابان اصلی:</Text>
									<Text strong>{formData?.profile?.mainStreet}</Text>
								</Space>
							</Paragraph>
						</Col>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>خیابان فرعی:</Text>
									<Text strong>{formData?.profile?.auxiliaryRoad}</Text>
								</Space>
							</Paragraph>
						</Col>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>کوچه:</Text>
									<Text strong>{formData?.profile?.alley}</Text>
								</Space>
							</Paragraph>
						</Col>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>پلاک:</Text>
									<Text strong>{formData?.profile?.buildingNo}</Text>
								</Space>
							</Paragraph>
						</Col>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>طبقه:</Text>
									<Text strong>{formData?.profile?.floor}</Text>
								</Space>
							</Paragraph>
						</Col>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>واحد:</Text>
									<Text strong>{formData?.profile?.unit}</Text>
								</Space>
							</Paragraph>
						</Col>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>تلفن:</Text>
									<Text strong dir="ltr">
										{formData?.profile?.tel}
									</Text>
								</Space>
							</Paragraph>
						</Col>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>کدپستی:</Text>
									<Text strong dir="ltr">
										{formData?.profile?.postalcode}
									</Text>
								</Space>
							</Paragraph>
						</Col>
					</Row>
				</Typography>
				<Divider />
				<div className="page_title">
					<h3>
						اطلاعات بانکی{" "}
						{isLogin && (
							<Link to={_adr.Root + _adr.Accounts.Index + _adr.Accounts.NewUser.Index + _adr.Accounts.NewUser.BankInfo} state={{ type: "edit" }}>
								<EditOutlined />
							</Link>
						)}
					</h3>
				</div>
				<Typography className={style.gapList}>
					<Row gutter={30}>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>نام بانک:</Text>
									<Text strong>{formData?.profile?.bankname}</Text>
								</Space>
							</Paragraph>
						</Col>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>شماره حساب بانکی:</Text>
									<Text strong dir="ltr">
										{formData?.profile?.bankaccountnumber || "-"}
									</Text>
								</Space>
							</Paragraph>
						</Col>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={12}>
							<Paragraph>
								<Space direction="vertical">
									<Text>شماره کارت:</Text>
									<Text strong dir="ltr">
										{formatDigit(formData?.profile?.cardnumber, 4, "-")}
									</Text>
								</Space>
							</Paragraph>
						</Col>
						<Col span={6} xxl={6} xl={6} lg={8} md={10} xs={24}>
							<Paragraph>
								<Space direction="vertical">
									<Text>شماره شبا</Text>
									<Text strong dir="ltr">
										IR{formData?.profile?.shebanumber}
									</Text>
								</Space>
							</Paragraph>
						</Col>
					</Row>
				</Typography>
				{!isLogin && (
					<Holder_button className={`holder-button ${style.btnReview}`}>
						<Button onClick={handleAcceptFinal} className="btn-aptel">
							{isLogin ? <>ویرایش</> : <>تایید تهایی</>}
						</Button>
						<Button onClick={() => nav(_adr.Root + _adr.Accounts.Index + _adr.Accounts.NewUser.Index + _adr.Accounts.NewUser.BankInfo)}>
							{isLogin ? <>انصراف</> : <>بازگشت</>}
						</Button>
					</Holder_button>
				)}
			</div>

			<MyModalAuctionResult
				width={"28.5rem"}
				open={openModal}
				onCancel={(e) => setOpenModal(false)}
				footer={[
					<div key="back">
						<Divider />
						<div className="holder-button">
							<Button key="back" onClick={handleNavToDirect} className="btn-aptel">
								شرکت در حراجی
							</Button>
						</div>
					</div>,
				]}>
				<div className="holder_show_content-result">
					<div className="hold_icon">
						<CheckOutlined />
					</div>
					<Typography>
						<Title level={3}>عملیات موفق</Title>
						<Text>
							اطلاعات حساب شما با موفقیت تکمیل شد. هم اکنون شما می‌توانید در مزایده‌ها شرکت کنید. حساب بانکی شما پس از بررسی طی ۲۴ ساعت آینده تایید
							خواهد شد.
						</Text>
					</Typography>
				</div>
			</MyModalAuctionResult>

			<Loading isOpen={loading} />
		</>
	);
};

export default Review;
